import { green, grey } from '@mui/material/colors'
import { THEMES } from '../constants'
import { createTheme } from '@mui/system'
import { rgba } from 'polished'
import { PaletteColor, Theme } from '@mui/material'

const customBlue = {
    50: '#e9f0fb',
    100: '#c8daf4',
    200: '#a3c1ed',
    300: '#7ea8e5',
    400: '#6395e0',
    500: '#4782da',
    600: '#407ad6',
    700: '#376fd0',
    800: '#2f65cb',
    900: '#2052c2 ',
}

export const financeLabVariant = {
    name: THEMES.FINANCE_LAB,
    palette: {
        mode: 'light',
        primary: {
            main: customBlue[700],
            contrastText: '#FFF',
        },
        secondary: {
            main: customBlue[500],
            contrastText: '#FFF',
        },
        background: {
            default: '#F7F9FC',
            paper: '#FFF',
        },
        action: {
            selectedText: customBlue[700],
            selectedHover: rgba(customBlue[700], 0.09),
            selected: rgba(customBlue[700], 0.125),
        },
    },
    header: {
        color: grey[500],
        background: '#FFF',
        search: {
            color: grey[800],
        },
        indicator: {
            background: customBlue[600],
        },
    },
    footer: {
        color: grey[500],
        background: '#FFF',
    },
    sidebar: {
        color: grey[200],
        background: '#233044',
        header: {
            color: grey[200],
            background: '#233044',
            brand: {
                color: customBlue[500],
            },
        },
        footer: {
            color: grey[200],
            background: '#1E2A38',
            online: {
                background: green[500],
            },
        },
        badge: {
            color: '#FFF',
            background: customBlue[500],
        },
    },
}

export interface FinanceLabTheme {
    palette: {
        success: PaletteColor
        info: PaletteColor
        warning: PaletteColor
        entityStatus: { complete: string; incomplete: string; ongoing: string; cancelled: string }
        FE: PaletteColor
        AE: PaletteColor
        RE: PaletteColor
        ABB: PaletteColor
        TO: PaletteColor
        IPO: PaletteColor
        SPEC: PaletteColor
        KV: PaletteColor
        rowColor: PaletteColor
    }
}

export const appendFLtheme = (theme: Theme) => {
    return createTheme(theme, {
        // Custom colors created with augmentColor go here
        palette: {
            success: theme.palette.augmentColor({
                color: {
                    main: '#4CAF4F',
                    light: '#4caf4f80',
                },
                name: 'success',
            }),
            info: theme.palette.augmentColor({
                color: {
                    main: '#4781db',
                    200: customBlue[200],
                    300: customBlue[300],
                    400: customBlue[400],
                    500: customBlue[500],
                    700: customBlue[700],
                    900: customBlue[900],
                    light: '#c6d8f4',
                },
                name: 'info',
            }),
            warning: theme.palette.augmentColor({
                color: {
                    main: '#ff980080',
                },
            }),
            DataGrid: {
                bg: 'transparent',
            },
            entityStatus: {
                incomplete: '#FF9800',
                complete: '#1b5e1f',
                ongoing: '#388e3b',
                cancelled: '#ed6c02',
            },
            FE: theme.palette.augmentColor({
                color: {
                    main: '#4CAF4F',
                    // https://m2.material.io/inline-tools/color/
                    200: '#a5d6a7',
                    700: '#388e3b',
                    900: '#1b5e1f',
                },
                name: 'företrädesemission',
            }),
            AE: theme.palette.augmentColor({
                color: {
                    main: '#4782DA',
                },
                name: 'appoteksemission',
            }),
            RE: theme.palette.augmentColor({
                color: {
                    main: '#FF9800',
                },
                name: 'riktad emission',
            }),
            ABB: theme.palette.augmentColor({
                color: {
                    main: '#FF9800',
                },
                name: 'accelerated bookbuilding',
            }),
            TO: theme.palette.augmentColor({
                color: {
                    main: '#D9D9D9',
                    dark: '#000000',
                },
                name: 'teckningsoption',
            }),
            IPO: theme.palette.augmentColor({
                color: {
                    main: '#EF534F',
                },
                name: 'ipo',
            }),
            SPEC: theme.palette.augmentColor({
                color: {
                    main: '#D9D9D9',
                },
                name: 'speciell unitemission',
            }),
            KV: theme.palette.augmentColor({
                color: {
                    main: '#AA4586',
                },
                name: 'konvertibellån',
            }),
            rowColor: theme.palette.augmentColor({
                color: {
                    main: rgba(55, 111, 208, 0.06),
                },
                name: 'rowColor',
            }),
        },
    } as FinanceLabTheme)
}
